import * as moment from 'moment'

export class UserTransformer {
  static transform (obj) {
    let user = {}
    const data = obj.hasOwnProperty('attributes') ? obj.attributes : obj
    user.id = obj.id
    user.firstName = data.first_name
    user.lastName = ''
    // user.lastName = data.last_name
    user.fullName = data.full_name
    user.email = data.email_address
    user.mobile = data.mobile_number
    user.groupId = data.group_id ? parseInt(data.group_id, 10) : data.group_id
    user.is_admin = data.is_admin ? 1 : 0
    user.spend_limit = data.spend_limit
    user.createdAt = moment(data.created_at).format('YYYY-MM-DD h:mm a')
    user.groupIdApp = data.group_id_app
    user.orderRecipient = data.order_recipient
    user.orderRecipientSms = data.order_recipient_sms
    user.active = data.active
    user.archivedAt = data.archived_at
    user.firmId = data.firm_id
    user.default_x = data.default_x
    user.default_y = data.default_y
    user.awayStart = data.away_start
    user.awayEnd = data.away_end
    user.delegateUserId = data.delegate_user_id
    user.model_type = data.model_type;
    user.thirdPartyCode = data.third_party_code;
    
    return user
  }

  static transformArray (array = []) {
    let data = []
    array.map(function (item) {
      data.push(UserTransformer.transform(item))
    })
    return data
  }
}



// WEBPACK FOOTER //
// ./src/helpers/users/user.transformer.js